import React from 'react'
import { Typography } from '@mui/material'

const PasswordInfo = () => (
    <>
        <Typography variant="h6" gutterBottom>
            Password must have:
        </Typography>
        <Typography>
            {'Atleast 8 characters'}
            <br />
            {'At least one uppercase letter'}
            <br />
            {'At least one lowercase letter'}
            <br />
            {'At least one number'}
            <br />
            {'Inclusion of atleast one special character, e.g.., @$!%*?#^&'}
        </Typography>
    </>
)
export default PasswordInfo
